import { alpha } from "@mui/material";

export const mainTheme = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
    },
  },

  palette: {
    primary: {
      main: "#1E3A5F", // Azul escuro sóbrio
      light: "#486A8C", // Azul médio
      dark: "#14273D", // Azul quase preto
      contrastText: "#FFF",
    },
    secondary: {
      main: "#6D757D", // Cinza sofisticado
      light: "#A0A7AD", // Cinza claro
      dark: "#4E545A", // Cinza escuro
      contrastText: "#FFF",
    },
    error: {
      main: "#C53030", // Vermelho sério
      light: "#E57373",
      dark: "#8B1A1A",
      contrastText: "#FFF",
    },
    warning: {
      main: "#D69E2E", // Amarelo ouro discreto
      light: "#F6E05E",
      dark: "#B7791F",
      contrastText: "#FFF",
    },
    info: {
      main: "#2C7A7B", // Verde azulado profissional
      light: "#319795",
      dark: "#1D4D4F",
      contrastText: "#FFF",
    },
    success: {
      main: "#2F855A", // Verde escuro corporativo
      light: "#38A169",
      dark: "#22543D",
      contrastText: "#FFF",
    },
    text: {
      primary: "#2D3748", // Cinza grafite para leitura confortável
      secondary: "#4A5568", // Cinza médio
      disabled: "#718096", // Cinza claro
    },
    divider: "#CBD5E0", // Cinza neutro para divisores
    background: {
      paper: "#FFFFFF",
      default: "#F8FAFC", // Quase branco para um visual limpo
    },
    action: {
      active: "#2D3748",
      hover: "#E2E8F0",
    },
  },
  shadows: [
    "none",
    "0px 2px 4px rgba(0, 0, 0, 0.08)",
    "0px 3px 6px rgba(0, 0, 0, 0.10)",
    "0px 4px 8px rgba(0, 0, 0, 0.12)",
    "0px 5px 10px rgba(0, 0, 0, 0.14)",
    "0px 6px 12px rgba(0, 0, 0, 0.16)",
    "0px 7px 14px rgba(0, 0, 0, 0.18)",
  ],
  typography: {
    fontFamily: "Inter, sans-serif",
  },
};
